<template>

  <ControlloFattureAcquisto />
 
</template>

<script>
import ControlloFattureAcquisto from '../components/pratiche/ControlloFattureAcquisto.vue'

export default {
  pageName: 'fatture',
  components: {
    ControlloFattureAcquisto

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
